import { Injectable } from '@angular/core';
import { Configuration, PointsRacesService } from '../../api-client';
import { HttpClient } from '@angular/common/http';
import { PointsRace } from '../../models/pointsRace';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PointsRaceService extends PointsRacesService {
  pointsRaces: PointsRace[] = [];
  
  constructor(httpClient: HttpClient, config: Configuration) {
    super(httpClient, config.basePath!, config);
  }

  getAll(): Observable<PointsRace[]> {
    return super.getPointsRacesEndpoint().pipe(
      map((pointsRaces: PointsRace[]) =>
        pointsRaces.map((pointsRace, index) => ({
          ...pointsRace,
          id: index,
        }))
      ),
      tap((pointsRaces: PointsRace[]) => {
        this.pointsRaces = pointsRaces;
      })
    );
  }
}
